import { Flex, Menu, MenuProps } from "antd";
import { FC } from "react";
import { Link, useLocation } from "react-router";

import { Logo } from "@/components/Logo";

import BarChartIcon from "@/assets/bar-chart.svg?react";
import BookIcon from "@/assets/book.svg?react";
import ProgramsIcon from "@/assets/programs.svg?react";
import NewsIcon from "@/assets/news.svg?react";
import GroupIcon from "@/assets/group.svg?react";
import HourGlassIcon from "@/assets/hourglass.svg?react";
import Reports from "@/assets/reports.svg?react";
import { useMeQuery } from "@/graphql";

const navigationItems: MenuProps["items"] = [
  // {
  //   key: "admin-dashboard",
  //   icon: <BarChartIcon />,
  //   label: <Link to={"dashboard"}>Dashboard</Link>,
  // },
  {
    key: "admin-programs",
    icon: <ProgramsIcon />,
    label: <Link to={"programs"}>Programs</Link>,
  },
  {
    key: "admin-courses",
    icon: <BookIcon />,
    label: <Link to={"courses"}>Courses</Link>,
  },

  {
    key: "admin-users",
    icon: <GroupIcon />,
    label: <Link to={"users"}>Users</Link>,
  },
  {
    key: "content",
    icon: <NewsIcon />,
    className: "custom-submenu-title",
    label: "Content",
    children: [
      { key: "admin-posts", label: <Link to={"posts"}>Post Feed</Link> },
      { key: "admin-notifications", label: <Link to={"notifications"}>Notifications</Link> },
    ],
  },
  {
    key: "reports",
    icon: <Reports />,
    className: "custom-submenu-title",
    label: "Reports",
    children: [
      { key: "admin-reports-programs", label: <Link to={"reports/programs"}>Programs</Link> },
      { key: "admin-reports-courses", label: <Link to={"reports/courses"}>Courses</Link> },
      { key: "admin-reports-users", label: <Link to={"reports/users"}>Users</Link> },
    ],
  },
  {
    key: "admin-activity-log",
    icon: <HourGlassIcon />,
    label: <Link to={"activity-log"}>Activity Log</Link>,
  },
];

export const Sider: FC = () => {
  const skipMeQuery = localStorage.getItem("accessToken") === null || localStorage.getItem("refreshToken") === null;
  const { data: meData } = useMeQuery({ skip: skipMeQuery });

  const { pathname } = useLocation();

  const currLocation = pathname.slice(1).split("/").join("-");

  return (
    <Flex rootClassName="sider-container" vertical align="center" gap={"120px"}>
      <Logo type="admin" className="sider-logo" />
      <Flex rootClassName="navigation-menu-container" vertical>
        <Menu
          rootClassName="navigation-menu"
          mode="inline"
          items={navigationItems.filter(
            (item) =>
              !(item?.key && ["admin-users", "content", "admin-activity-log"].includes(item.key as string) && meData?.me?.role?.type?.includes("creator"))
          )}
          defaultSelectedKeys={currLocation ? [currLocation] : undefined}
        />
      </Flex>
    </Flex>
  );
};
